<template>
    <div @click="$emit('cerrar')">
       <div  class="cargando">
            <v-progress-circular
            indeterminate
            color="#2562a4"
          ></v-progress-circular>
        </div>
        <StreamBarcodeReader
          @decode="(a, b, c) => onDecode(a, b, c)"
          @error="() => onError()"
          @loaded="() => onLoaded()"
        ></StreamBarcodeReader>
        <div class="p-10 text-center d-none">
          <h5>{{ text || "Código no válido" }}</h5>
          <input text ref="textEan" v-model="eanOcultoScan" @keyup.enter="$emit('search-by-ean-code', eanOcultoScan)"/>
        </div>
  </div>
</template>

<script>
import { StreamBarcodeReader } from "vue-barcode-reader";

export default {
  name: "CodeScanner",
  cargando: true,
  components: {
    StreamBarcodeReader,
  },
  data() {
    return {
      text: "",
      id: null,
      eanOcultoScan: '',
    };
  },
  props: {
    msg: String,
  },
  mounted() {
   this.$refs.textEan.focus()
  },
  methods: {
    onDecode(a, b, c) {
      console.log(a, b, c);
      this.text = a;
      this.$emit('search-by-ean-code', a)
      if (this.id) clearTimeout(this.id);
      this.id = setTimeout(() => {
        if (this.text === a) {
          this.text = "";
        }
      }, 5000);
    },
    onLoaded() {
      console.log("load");
    },
    onError(){
      this.$root.$emit('mostrarAlerta', this.$t('lang.comun.error'), 'error')
    }
  },
};
</script>
